export const UserRoles = [
  { id: 2, name: "Admin" },
  { id: 3, name: "User" },
  { id: 4, name: "Coordinator" },
];
